<div class="sections">
	@for (section of sections; track section; let i = $index) {
		<button [class.selected]="selectedSection?.uuid == section.uuid" (click)="selectSection(section)">
			{{ section.name }}
		</button>
	}
</div>
